import { ComponentProps, ComponentType } from 'react';

import { mergeClasses } from '@/utils';

import { InfoCircleIcon } from '@/assets/icons';
import { SvgIcon } from '@/components/common';

import { PromptMessageVariant, PROMPT_MESSAGE_VARIANTS } from './PromptMessage.constants';

interface IPromptMessageProps {
  message: string;
  variant?: PromptMessageVariant;
  icon?: ComponentType<{ className?: string }>;
  className?: string;
}

const PromptMessage: React.FC<IPromptMessageProps> = ({
  message,
  variant = 'info',
  icon,
  className,
}: IPromptMessageProps) => {
  const variantStyles = PROMPT_MESSAGE_VARIANTS[variant];

  return (
    <div
      className={mergeClasses(
        'font-medium text-body-sm w-fit flex items-center justify-between rounded-[8px] py-4 px-5 text-neutral-9 border',
        variantStyles.container,
        className,
      )}
    >
      <div className="flex items-center gap-3">
        {icon && (
          <SvgIcon
            className={mergeClasses('size-6 shrink-0', variantStyles.icon)}
            component={icon}
          />
        )}
        <div className={mergeClasses('break-normal !text-neutral-9 dark:!text-neutral-0')}>
          {message}
        </div>
      </div>
    </div>
  );
};

const CustomPromptMessage = ({ className, children, ...props }: ComponentProps<'div'>) => {
  return (
    <div
      className={mergeClasses(
        'flex flex-row w-full items-center justify-start gap-3 px-5 py-4 rounded-lg bg-semantic-info-light',
        className,
      )}
      {...props}
    >
      <InfoCircleIcon className="size-6 text-semantic-info-base shrink-0" />
      {children}
    </div>
  );
};

export { PromptMessage, CustomPromptMessage };
